const config = window.AbdelmegedTheme || {};
const forms = document.querySelectorAll('[data-newsletter-form]');
const endpoint = `${config.restUrl || '/wp-json/abdelmeged/v1'}/newsletter/subscribe`;

const labels = {
  success: {
    ar: 'تم إرسال رسالة التأكيد إلى بريدك إذا كان العنوان صحيحًا.',
    en: 'A confirmation message has been sent if the email is valid.',
  },
  error: {
    ar: 'تعذر إرسال الاشتراك الآن. حاول مرة أخرى بعد قليل.',
    en: 'The subscription could not be sent right now. Please try again shortly.',
  },
  invalid: {
    ar: 'اكتب بريدًا إلكترونيًا صحيحًا.',
    en: 'Enter a valid email address.',
  },
};

const language = () => (config.language === 'en' ? 'en' : 'ar');

const text = (key) => labels[key]?.[language()] || labels[key]?.ar || '';

const setMessage = (form, message, tone = 'info') => {
  const element = form.querySelector('[data-newsletter-message]');

  if (!element) {
    return;
  }

  element.textContent = message;
  element.dataset.tone = tone;
};

const payloadFor = (form) => {
  const data = new FormData(form);

  return {
    email: String(data.get('email') || '').trim(),
    language: String(data.get('language') || config.language || 'ar'),
    direction: String(data.get('direction') || config.direction || 'rtl'),
    source: form.dataset.newsletterSource || 'site',
    website: String(data.get('website') || ''),
  };
};

const setLoading = (form, loading) => {
  form.setAttribute('aria-busy', String(loading));
  form.querySelectorAll('input, button').forEach((element) => {
    element.disabled = loading;
  });
};

const submit = async (form) => {
  const payload = payloadFor(form);

  if (!payload.email || !form.checkValidity()) {
    setMessage(form, text('invalid'), 'error');
    form.reportValidity();
    return;
  }

  setLoading(form, true);
  setMessage(form, '');

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Newsletter request failed.');
    }

    form.reset();
    setMessage(form, text('success'), 'success');
    window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'newsletter' } }));
  } catch {
    setMessage(form, text('error'), 'error');
  } finally {
    setLoading(form, false);
  }
};

if (config.features?.newsletter !== false) {
  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submit(form);
    });
  });
}
